import React, { Component } from 'react'
import { LEGISLATURE_NAME_MAPPING } from '../../constants'

import ProjectStats from '../Projects/ProjectStats'
import PowerProjectTable from '../Tables/PowerProjectTable'
import OtherProjectTable from '../Tables/OtherProjectTable'

import '../App/ExpandableList.css'

class Riding extends Component {
  constructor (props) {
    super(props)
    this.state = {
      riding: null
    }
  }

  render () {
    const r = this.props.riding
    const rep = r ? r.rep : null

    const legislativeBodyName = LEGISLATURE_NAME_MAPPING[this.props.level]

    return (
      <div className='Riding'>
        <h1>
          {r && r.name}
          {this.props.level === 'fed' && r &&
            <span className='text-muted'>&nbsp;({r.provinceCode})</span>
          }
        </h1>
        <p className='lead'>{legislativeBodyName}</p>
        {r &&
          <div className='row'>
            <div className='col'>
              <h2>Representative</h2>
              <div className='row'>
                <div className='col-4'>
                  {rep.photoURL
                    ? <img src={rep.photoURL}
                      alt={`Portrait of ${rep.name}`}
                      title={`Portrait of ${rep.name}`}
                    />
                    : <p class='text-muted'>No photo available.</p>
                  }

                </div>
                <div className='col-8'>
                  <p className='lead'>{rep.name}</p>
                  <p>{rep.party}</p>
                  <p><a href={`mailto:${rep.email}`}>{rep.email}</a></p>
                  <p>{rep.phone}</p>
                  <p><a href={rep.website} target='_blank'>Website</a></p>
                </div>
              </div>
            </div>
            <div className='col'>
              {r && r.powerProjectArray().length > 0 &&
                <div>
                  <h2>Power project overview</h2>
                  <ProjectStats projectTotals={r.powerProjectTotals()} />
                </div>
              }
            </div>
          </div>
        }
        <br />
        {r && r.powerProjectArray().length > 0
          ? <div>
            <h2>Power projects</h2>
            <PowerProjectTable simpleListing powerProjects={r.powerProjectArray()} />
          </div>
          : <div>
            <h2>No power projects</h2>
            <p>No power projects in the data repository.</p>
          </div>
        }
        {r && r.otherProjectArray().length > 0
          ? <div>
            <h2>Other projects</h2>
            <OtherProjectTable simpleListing otherProjects={r.otherProjectArray()} />
          </div>
          : <div>
            <h2>No other projects</h2>
            <p>No other projects in the data repository.</p>
          </div>
        }

      </div>
    )
  }
}

export default Riding



// WEBPACK FOOTER //
// ./src/components/Ridings/Riding.js